export const DATA_PRESET_ATTRIBUTE = 'data-preset'
export const CSS_PRESET_PREFIX = '--preset'
export const COMPONENT_CLASS_PREFIX = 'w-'
export const ROOT_ELEMENT_KEY = 'root'
export const PRESETS_WRAPPER_CLASS = 'wix-presets-wrapper'
export const MUTATION_OBSERVER_DEBOUNCE_MS = 50
